import { CircularProgress } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import { maxInputWidth } from "~/components/sizes";
import styles from "./style.module.less";
interface InputWithActionsProps {
    input: JSX.Element;
    actions: JSX.Element;
    applyMaxWidth?: boolean;
    maxWidthInRem?: number;
    busy?: boolean;
    actionsAlignment?: "center" | "start" | "end";
}
const InputWithActions: React.FC<InputWithActionsProps> = (props) => {
    const inputStyle = props.applyMaxWidth ? { maxWidth: maxInputWidth } : props.maxWidthInRem ? { maxWidth: `${props.maxWidthInRem}rem` } : {};
    const actionsStyle = props.actionsAlignment ? { alignItems: props.actionsAlignment } : {};
    return (<div className={styles.container}>
            <div className={styles.input} style={inputStyle}>
                {props.input}
            </div>
            <div className={styles.actions} style={actionsStyle}>
                {props.actions}
                {props.busy && <CircularProgress size={"small"}/>}
            </div>
        </div>);
};
InputWithActions.displayName = "InputWithActions"
InputWithActions.displayName = "InputWithActions";
export default InputWithActions;
